import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import CloseIcon from "@mui/icons-material/Close";
import ColorizeIcon from "@mui/icons-material/Colorize";
import DeleteIcon from "@mui/icons-material/Delete";
import DeselectIcon from "@mui/icons-material/Deselect";
import DownloadIcon from "@mui/icons-material/Download";
import EditIcon from "@mui/icons-material/Edit";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ImageIcon from "@mui/icons-material/Image";
import OutputIcon from "@mui/icons-material/Output";
import UploadIcon from "@mui/icons-material/Upload";
import {
  Backdrop,
  Card,
  Checkbox,
  CircularProgress,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  IconButton,
  Paper,
  Radio,
  RadioGroup,
  Slider,
  Tab,
  Tabs,
  Tooltip,
} from "@mui/material";
// location: frontend/qiankun/upstyledpkgs/tui.image-editor-3.15.3
// must yarn remove tui-image-editor @toast-ui/react-image-editor
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import ImageEditor from "@toast-ui/react-image-editor";
import { Upload } from "antd";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiInput from "components/SuiInput";
import SuiTypography from "components/SuiTypography";
import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";
import Prompt, { SimplePrompt } from "components/UpStyled/Prompt";
import TabPanel from "components/UpStyled/TabPanel";
import Compressor from "compressorjs";
import { AccountContext } from "context/account";
import { saveAs } from "file-saver";
import { nanoid } from "nanoid";
import NewSharedBar from "pages/de/share-page/newsharebar";
import AILabPageTurorialModal from "pages/tutorial/AILabPageTurorialModal";
import {
  forwardRef,
  useCallback,
  useContext,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import Draggable from "react-draggable";
import toast from "react-hot-toast";
import "react-image-crop/dist/ReactCrop.css";
import { Group, Image as KonvaImage, Layer, Line, Shape, Stage } from "react-konva";
import "react-multi-carousel/lib/styles.css";
import api from "services/api";
import "tui-image-editor/dist/tui-image-editor.css";
import useImage from "use-image";
import { dataURLtoFile, getImageDimensions } from "utils/imageHelper";
import { combineSegment, convertToRLE, processArea } from "./algo";
import { BackgroundColorTheif } from "./backgroundcolor";
import colors from "assets/theme/base/colors";
import { useLocation } from "react-router-dom";
import qs from "query-string";

const smartdate = require("smartdate");
smartdate.init();

const defaultConfig = {
  task_type: "",
  prompt: "",
  negative_prompt: "",
  batch_size: 4,
  max_num_inference_steps: 20,
  conditioning_scale: 1,
  guidance_scale: 7,
  coarse: false,
};

function resizeImg(file, width, height) {
  return new Promise((resolve, _) => {
    new Compressor(file, {
      strict: false,
      width: width,
      height: height,
      resize: "contain",
      quality: 0.92,
      mimeType: "image/jpeg",
      success: async (result) => {
        resolve(result);
      },
      error(err) {
        toast.error(err.message);
      },
    });
  });
}

const Segment = ({ segment, fill = undefined, color, strokeWidth, sketchWidth, sketchHeight }) => {
  //console.log('segment', segment)
  return (
    <Group>
      {segment.pointsArray.map((points, i) => (
        <Shape
          key={segment.id + "_" + i}
          sceneFunc={(context, shape) => {
            context.beginPath();
            context.moveTo(points[0].x * sketchWidth, points[0].y * sketchHeight);
            for (var i = 1; i < points.length; ++i)
              context.lineTo(points[i].x * sketchWidth, points[i].y * sketchHeight);
            context.lineTo(points[0].x * sketchWidth, points[0].y * sketchHeight);
            context.fillStrokeShape(shape);
          }}
          fill={fill ? fill : color}
          stroke={color}
          strokeWidth={strokeWidth}
          opacity={fill ? 1 : 0.3}
        />
      ))}
    </Group>
  );
};

const ShowSegmentImage = forwardRef((props, ref) => {
  var segmentsRef = props.segmentsRef;
  var sketchWidth = props.sketchWidth;
  var sketchHeight = props.sketchHeight;
  var sketchData = props.sketchData;
  var account = props.account;

  const [background] = useImage(sketchData?.imgurl, "anonymous", "origin");
  const [segmentData, setSegmentData] = useState([]);
  const [matchedSegment, setMatchedSegment] = useState(null);
  const [waiting, setWaiting] = useState(null);
  const [segmentImage, setSegmentImage] = useState(null);
  const [brushLine, setBrushLine] = useState(null);
  const [selectedSegment, setSelectedSegment] = useState(null);
  const [coloredSegment, setColoredSegment] = useState(null);
  const [inpaintMode, setInpaintMode] = useState("Click");
  const [brushSize, setBrushSize] = useState(12);
  const [showColorDialog, setShowColorDialog] = useState(false);

  const segmentImgRef = useRef(null);
  const isDrawing = useRef(false);
  const runningRef = useRef(false);
  const backgroundColorRef = useRef("#FFFFFF");

  useEffect(() => {
    var func = props.inpaintRef.current?.setSelectedAreaPercFunc;
    if (func === null) return;
    if (selectedSegment === null) {
      func(null);
      return;
    }
    //console.log('selectedSegment', selectedSegment.maskArea.filter((m) => m > 0).length, selectedSegment.area)
    func(Math.round((selectedSegment.area * 100) / sketchHeight / sketchHeight) + "%");
  }, [selectedSegment]);

  //console.log('selectedSegment', selectedSegment)

  useImperativeHandle(ref, () => ({
    selectedSegment: selectedSegment,
  }));

  const FillColorDialog = ({}) => {
    const [backgroundColor, setBackgroundColor] = useState(backgroundColorRef.current);
    const inputRef = useCallback(async (node) => {
      if (node !== null) {
        await new Promise((res) => setTimeout(res, 50));
        //node.click();
      }
    }, []);

    function PaperComponent(props) {
      return (
        <Draggable
          handle="#draggable-color-dialog-title"
          cancel={'[class*="MuiDialogContent-root"]'}
        >
          <Paper {...props} />
        </Draggable>
      );
    }

    return (
      <Dialog
        hideBackdrop={true}
        fullWidth
        maxWidth="xs"
        open={showColorDialog}
        onClose={() => setShowColorDialog(false)}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-color-dialog-title"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "550px",
              maxWidth: "550px",
              height: "350px",
            },
          },
        }}
      >
        <DialogTitle id="draggable-color-dialog-title" style={{ cursor: "move" }}>
          Pick a color to fill the designated area.
          <IconButton
            aria-label="close"
            onClick={() => {
              setShowColorDialog(false);
              reset();
            }}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <SuiBox
            sx={{ height: "100%", width: "100%" }}
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            alignItems="flex-start"
          >
            <div style={{ width: "100%" }}>
              <SuiBox my={1} mb={2}>
                <SuiBox lineHeight={0}>
                  <SuiTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                    textTransform="capitalize"
                  >
                    Color
                  </SuiTypography>
                </SuiBox>
                <SuiBox display="flex" justifyContent="space-between" alignItems="center">
                  <input
                    ref={inputRef}
                    type="color"
                    value={backgroundColor}
                    style={{
                      width: 60,
                      height: 60,
                      cursor: "pointer",
                    }}
                    onChange={(e) => {
                      backgroundColorRef.current = e.target.value;
                    }}
                    onBlur={(e) => {
                      setBackgroundColor(backgroundColorRef.current);
                      if (coloredSegment)
                        setColoredSegment({ ...coloredSegment, color: backgroundColorRef.current });
                      else
                        setColoredSegment({
                          ...selectedSegment,
                          color: backgroundColorRef.current,
                        });
                      setSelectedSegment(null);
                    }}
                  />
                  <SuiTypography variant="body1">{backgroundColor}</SuiTypography>
                </SuiBox>
              </SuiBox>
            </div>
          </SuiBox>
        </DialogContent>
        <DialogActions>
          <SuiButton
            onClick={() => {
              saveSegmentImg();
              setShowColorDialog(false);
            }}
            color={"dark"}
            variant="gradient"
          >
            Save
          </SuiButton>
        </DialogActions>
      </Dialog>
    );
  };

  function getBackgroundColor() {
    var backgroundColorThief = new BackgroundColorTheif();
    var rgb = backgroundColorThief.getBackGroundColor(document.getElementById("backgroundImage"));
    const componentToHex = (c) => {
      const hex = c.toString(16);
      return hex.length == 1 ? "0" + hex : hex;
    };
    var hexCode = "#" + componentToHex(rgb[0]) + componentToHex(rgb[1]) + componentToHex(rgb[2]);
    //console.log('getBackgroundColor', hexCode)
    setBackgroundColor(hexCode);
  }

  const handleClick = (e) => {
    if (e.evt.button === 2) return;
    if (!matchedSegment || inpaintMode !== "Click") return;
    if (selectedSegment?.maskArea && matchedSegment?.maskArea) {
      const stage = e.target.getStage();
      const point = stage.getPointerPosition();
      var x = Math.max(0, Math.min(sketchWidth - 1, Math.round(point.x)));
      var y = Math.max(0, Math.min(sketchHeight - 1, Math.round(point.y)));
      var minus = selectedSegment.maskArea[x * sketchHeight + y] == 1;
      var result = combineSegment(selectedSegment, matchedSegment, minus);
      setSelectedSegment(result.pointsArray.length > 0 ? result : null);
    } else setSelectedSegment(matchedSegment);
  };

  const handleMouseDown = (e) => {
    if (inpaintMode !== "Click" && e.evt.button === 0) {
      isDrawing.current = true;
      setBrushLine([]);
    }
  };

  const handleMouseUp = (e) => {
    function calculateSquaredDistanceToLine(x, y, x1, y1, x2, y2) {
      const A = x - x1;
      const B = y - y1;
      const C = x2 - x1;
      const D = y2 - y1;
      const dotProduct = A * C + B * D;
      const lineLengthSquared = C * C + D * D;
      const param = dotProduct / lineLengthSquared;
      let closestX, closestY;
      if (param < 0) {
        closestX = x1;
        closestY = y1;
      } else if (param > 1) {
        closestX = x2;
        closestY = y2;
      } else {
        closestX = x1 + param * C;
        closestY = y1 + param * D;
      }
      const dx = x - closestX;
      const dy = y - closestY;
      return dx * dx + dy * dy;
    }

    if (isDrawing.current) {
      isDrawing.current = false;
      if (brushLine.length > 0) {
        var target = inpaintMode === "Brush" ? 1 : 0;
        var r = Math.floor(brushSize / 2);
        var r2 = r * r;
        //console.log('brushLine', brushLine, 'brushSize', brushSize)
        var newSelectedArea = selectedSegment
          ? [...selectedSegment.maskArea]
          : Array(sketchWidth * sketchHeight).fill(0);
        for (var p = 1; p < brushLine.length / 2; ++p) {
          var x1 = brushLine[2 * p - 2];
          var y1 = brushLine[2 * p - 1];
          var x2 = brushLine[2 * p];
          var y2 = brushLine[2 * p + 1];
          var bx = Math.max(0, Math.min(x1, x2) - r);
          var ex = Math.min(sketchWidth - 1, Math.max(x1, x2) + r);
          var by = Math.max(0, Math.min(y1, y2) - r);
          var ey = Math.min(sketchHeight - 1, Math.max(y1, y2) + r);
          for (var x = bx; x < ex; ++x) {
            for (var y = by; y < ey; ++y) {
              if (newSelectedArea[x * sketchHeight + y] === target) continue;
              var d2 = calculateSquaredDistanceToLine(x, y, x1, y1, x2, y2);
              if (d2 <= r2) {
                newSelectedArea[x * sketchHeight + y] = target;
              }
            }
          }
        }
        var result = processArea(newSelectedArea, sketchWidth, sketchHeight);
        if (!result.maskArea.includes(1)) setSelectedSegment(null);
        else if (selectedSegment) setSelectedSegment({ ...selectedSegment, ...result });
        else
          setSelectedSegment({
            crop_box: [0, 0, sketchWidth, sketchHeight],
            width: sketchWidth,
            height: sketchHeight,
            id: nanoid(),
            ...result,
          });
      }
      setBrushLine(null);
    }
  };

  const handleMouseMove = (e) => {
    const stage = e.target.getStage();
    const point = stage.getPointerPosition();
    var x = Math.max(0, Math.min(sketchWidth - 1, Math.round(point.x)));
    var y = Math.max(0, Math.min(sketchHeight - 1, Math.round(point.y)));
    if (isDrawing.current) {
      setBrushLine([...brushLine, x, y]);
      return;
    }
    if (inpaintMode !== "Click") return;
    if (segmentData.length === 0) return;
    /*if (selectedSegment && selectedSegment.maskArea[x * sketchHeight + y] == 1) {
      setMatchedSegment(null);
      return;
    }*/
    var result = null;
    for (var segment of segmentData) {
      //console.log('x', x, 'y', y, 'segment.maskArea[x * height + y]', segment.maskArea.slice(x * height, x * height + height))
      if (segment.maskArea[x * sketchHeight + y] == 1) {
        if (segment.color) {
          setMatchedSegment(null);
          return;
        }
        if (!result || result.area > segment.area) {
          result = segment;
        }
      }
    }
    setMatchedSegment(result);
  };

  const saveSegmentImg = async () => {
    setWaiting("Saving image...");
    setMatchedSegment(null);
    await new Promise((resolve) => setTimeout(resolve, 300));
    var sketch = document.getElementById("stage_parent");
    const uri = sketch?.childNodes[0]?.childNodes[0]?.childNodes[0]?.toDataURL();
    const file = dataURLtoFile(uri, nanoid());
    var blob = await resizeImg(file, sketchWidth, sketchHeight);
    var file2 = new File([blob], file.name, { type: file.type });
    const uploadedImg = await api.uploads
      .create([file2], {}, props.ailab_id)
      .then(({ data }) => {
        const uploaded = data.uploads.map(({ url }) => url);
        return uploaded;
      })
      .catch((err) => {
        console.log(err);
        toast.error("Save image failed!");
      });
    if (uploadedImg.length === 1) {
      var url = uploadedImg[0];
      const { width, height } = await getImageDimensions(url);
      props.setSketchData({ ...sketchData, imgurl: url, width: width, height: height });
      props.setIsDirty(true);
    }
    setWaiting(null);
  };

  const reset = () => {
    var newsegmentData = segmentData.map((s) => {
      return { ...s, color: undefined };
    });
    setSegmentData(newsegmentData);
    setSelectedSegment(null);
    setColoredSegment(null);
  };

  return (
    <SuiBox>
      {segmentImage && (
        <Prompt
          visible={segmentImage !== null}
          handleClose={() => setSegmentImage(null)}
          handleOk={() => setSegmentImage(null)}
          option={{ maxWidth: "xl" }}
          text={
            <SuiBox
              pt={1}
              display="flex"
              justifyContent="center"
              alignItems="center"
              sx={{ minWidth: 300, minHeight: 300 }}
            >
              {segmentImage.map((img) => (
                <img style={{ border: "1px solid black", marginRight: "10px" }} src={img} />
              ))}
            </SuiBox>
          }
          hideAction
        />
      )}
      <Backdrop sx={{ color: "info", zIndex: (theme) => 99999 }} open={waiting !== null}>
        <CircularProgress color="info" sx={{ mr: 1 }} size={32} />
        <SuiTypography variant="h6" fontWeight="medium" color="info">
          {waiting}
        </SuiTypography>
      </Backdrop>
      <FillColorDialog />
      <SuiBox display="flex" justifyContent="center" sx={{ width: "100%", mt: 3 }}>
        <SuiBox sx={{ width: 230, minWidth: 230 }}>
          <SuiBox display="flex" sx={{ width: "100%", lineHeight: 1.25, mx: 1 }}>
            <SuiTypography fontWeight="medium">Select a designated area:</SuiTypography>
          </SuiBox>
          <SuiBox display="flex" alignItems="center" sx={{ mx: 1, ml: 4 }}>
            <RadioGroup
              aria-label="one"
              name="one"
              column
              onChange={(e) => {
                setInpaintMode(e.target.value);
              }}
              value={inpaintMode}
            >
              <FormControlLabel
                value="Click"
                control={<Radio color="primary" />}
                label={
                  <Tooltip
                    title={"Move mouse to view segments and click to add segment."}
                    placement="left"
                  >
                    <SuiTypography sx={{ mr: 5 }}>Hover</SuiTypography>
                  </Tooltip>
                }
                labelPlacement="end"
              />
              <FormControlLabel
                value="Brush"
                control={<Radio color="primary" />}
                label={
                  <Tooltip
                    title={"Paint with your mouse to add the designated area."}
                    placement="left"
                  >
                    <SuiTypography sx={{ mr: 5 }}>Brush</SuiTypography>
                  </Tooltip>
                }
                labelPlacement="end"
              />
              <FormControlLabel
                value="Eraser"
                control={<Radio color="primary" />}
                label={
                  <Tooltip
                    title={"Erase with your mouse to clear the designated area."}
                    placement="left"
                  >
                    <SuiTypography sx={{ mr: 5 }}>Eraser</SuiTypography>
                  </Tooltip>
                }
                labelPlacement="end"
              />
            </RadioGroup>
          </SuiBox>
          <SuiBox display="flex" sx={{ width: "100%", lineHeight: 1.25, mx: 1 }}>
            <SuiTypography fontWeight="medium">Brusher/eraser size:</SuiTypography>
          </SuiBox>
          <SuiBox display="flex" alignItems="center" sx={{ width: "100%", px: 2 }}>
            <Slider
              step={2}
              value={brushSize}
              aria-label="Default"
              valueLabelDisplay="auto"
              min={2}
              max={100}
              onChange={(e) => {
                setBrushSize(e.target.value);
              }}
            />
          </SuiBox>
          <Tooltip title="Deselect the designated area" placement="left">
            <SuiButton
              sx={{ textTransform: "none", py: 0.5, mr: 10 }}
              size="large"
              variant="text"
              color="text"
              startIcon={<DeselectIcon fontSize="large" />}
              onClick={() => {
                if (selectedSegment) reset();
              }}
            >
              Deselect
            </SuiButton>
          </Tooltip>
          <Tooltip title="Show the designated area in a pop-up window" placement="left">
            <SuiButton
              sx={{ textTransform: "none", py: 0.5, mr: 10 }}
              size="large"
              variant="text"
              color="text"
              startIcon={<OutputIcon fontSize="large" />}
              onClick={() => {
                if (selectedSegment) {
                  var segment = selectedSegment;
                  if (segment.pointsArray.length === 0) {
                    setSegmentImage(null);
                    return;
                  }
                  var image = document.getElementById("backgroundImage");
                  //console.log('image', image.width, image.height)
                  //console.log('segment', segment)
                  var segmentimgs = [];
                  for (var points of segment.pointsArray) {
                    var xlist = points.map((p) => p.x);
                    var ylist = points.map((p) => p.y);
                    var dx = Math.min(...xlist) * image.width,
                      dy = Math.min(...ylist) * image.height,
                      dw = Math.max(...xlist) * image.width - dx,
                      dh = Math.max(...ylist) * image.height - dy;
                    var canvas = document.createElement("canvas");
                    canvas.width = dw;
                    canvas.height = dh;
                    var ctx = canvas.getContext("2d");
                    ctx.beginPath();
                    ctx.moveTo(points[0].x * image.width - dx, points[0].y * image.height - dy);
                    for (var i = 1; i < points.length; i++) {
                      ctx.lineTo(points[i].x * image.width - dx, points[i].y * image.height - dy);
                    }
                    ctx.closePath();
                    ctx.clip();
                    ctx.drawImage(image, dx, dy, dw, dh, 0, 0, dw, dh);
                    var dataURL = canvas.toDataURL();
                    segmentimgs.push(dataURL);
                  }
                  //console.log('dataURL', dataURL)
                  setSegmentImage(segmentimgs);
                  //document.removeChild(canvas)
                  canvas = null;
                } else toast.error("Please select the designated area first");
              }}
            >
              Extract
            </SuiButton>
          </Tooltip>
          <Tooltip title="Select a color to transform the designated area" placement="left">
            <SuiButton
              sx={{ textTransform: "none", py: 0.5, mr: 10 }}
              size="large"
              variant="text"
              color="text"
              startIcon={<ColorizeIcon fontSize="large" />}
              onClick={() => {
                if (selectedSegment) {
                  setMatchedSegment(null);
                  setShowColorDialog(true);
                } else toast.error("Please select the designated area first");
              }}
            >
              Fill Color
            </SuiButton>
          </Tooltip>
        </SuiBox>
        <SuiBox
          display="flex"
          sx={{
            overflow: "auto",
            width: sketchWidth + 2,
            height: sketchHeight + 2,
            border: "1px solid",
          }}
        >
          <SuiBox
            sx={{ width: sketchWidth, height: sketchHeight }}
            id={"stage_parent"}
            onMouseLeave={() => setMatchedSegment(null)}
          >
            <Stage
              ref={segmentImgRef}
              className="konva"
              width={sketchWidth}
              height={sketchHeight}
              onMouseDown={handleMouseDown}
              onMouseup={handleMouseUp}
              onMousemove={handleMouseMove}
              onClick={handleClick}
            >
              <Layer>
                <KonvaImage image={background} width={sketchWidth} height={sketchHeight} />
                {coloredSegment && (
                  <Segment
                    segment={coloredSegment}
                    fill={coloredSegment.color}
                    color={coloredSegment.color}
                    strokeWidth={5}
                    sketchWidth={sketchWidth}
                    sketchHeight={sketchHeight}
                  />
                )}
                {matchedSegment && (
                  <Segment
                    segment={matchedSegment}
                    color={"#0000FF"}
                    strokeWidth={2}
                    sketchWidth={sketchWidth}
                    sketchHeight={sketchHeight}
                  />
                )}
                {selectedSegment && selectedSegment.pointsArray.length > 0 && (
                  <Segment
                    segment={selectedSegment}
                    color={"#FF0000"}
                    strokeWidth={2}
                    sketchWidth={sketchWidth}
                    sketchHeight={sketchHeight}
                  />
                )}
                {brushLine && (
                  <Line
                    stroke={inpaintMode === "Brush" ? "#FF0000" : "#0000FF"}
                    strokeWidth={brushSize}
                    lineCap="round"
                    lineJoin="round"
                    points={brushLine}
                    opacity={0.3}
                  />
                )}
              </Layer>
            </Stage>
          </SuiBox>
        </SuiBox>
      </SuiBox>
    </SuiBox>
  );
});

const AILab = ({ ailab_id }) => {
  const [labData, setLabData] = useState(null);
  const [resultData, setResultData] = useState([]);
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const [sketchData, setSketchData] = useState(null);
  const [isDirty, setIsDirty] = useState(false);
  const [jobconf, setJobconf] = useState({ ...defaultConfig });
  const [inpaintJobconf, setInpaintJobconf] = useState({ ...defaultConfig });
  const [uploading, setUploading] = useState(false);
  const [editNameVisible, setEditNameVisible] = useState(false);
  const [inputWidth, setInputWidth] = useState(20);
  const [promptConfig, setPromptConfig] = useState(null);
  const [tabValue, setTabValue] = useState("text-to-image");
  const [expanded, setExpanded] = useState(false);
  const [largeDetailImage, setLargeDetailImage] = useState(null);
  const [tutorialVisible, setTutorialVisible] = useState(false);
  const [initEditImage, setInitEditImage] = useState(false);

  let location = useLocation();
  const url = location.href ? location.href : location.pathname + location.search;
  const urlObj = qs.parseUrl(url);
  const aiTab = urlObj?.query?.tab;

  const segmentsRef = useRef({});
  const segmentImageRef = useRef(null);
  const editImageRef = useRef(null);
  const inpaintRef = useRef(null);
  const resultRef = useRef(null);
  const focusRef = useRef(false);

  useEffect(() => {
    if (aiTab) {
      setTabValue(aiTab);
    }
  }, [aiTab]);

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
      value: index,
    };
  }

  const stageRef = useRef(null);
  const account = useContext(AccountContext);
  const nameInputRef = useRef(null);

  const [background] = useImage(sketchData?.imgurl, "anonymous", "origin");
  const maxImagePixels = 512;
  const leftPanelWidth = 500;
  const sketchWidth = maxImagePixels,
    sketchHeight = maxImagePixels;

  const taskOptions = [
    { label: "Canny", value: "gen.flat" },
    { label: "ControlNet", value: "gen.flat.cnet" },
    { label: "Scribble", value: "gen.flat.scribble" },
    { label: "Line art", value: "gen.lineart" },
    { label: "Stable diffusion", value: "gen.flat.sd" },
  ];

  const taskOptions_NoImg = [{ label: "gen.flat.sd", value: "gen.flat.sd" }];
  /*if ((sketchData?.height ?? 1) < (sketchData?.width ?? 1)) {
    var sketchWidth = maxImagePixels
    var sketchHeight = sketchWidth * (sketchData?.height ?? 1) / (sketchData?.width ?? 1)
  } else {
    var sketchHeight = maxImagePixels
    var sketchWidth = sketchHeight * (sketchData?.width ?? 1) / (sketchData?.height ?? 1)
  }*/

  //console.log('jobconf', jobconf)
  const loadAILab = async () => {
    api.ailab
      .get(ailab_id)
      .then(({ data }) => {
        //console.log('data', data.data)
        setLabData(data.data);
        if (data.data.metadata) {
          if (data.data.metadata.sketchData) {
            setSketchData(data.data.metadata.sketchData);
            //if (data.data.metadata.sketchData.imgurl) setTabValue(1);
          }
          if (data.data.metadata.resultData) setResultData(data.data.metadata.resultData);
          if (data.data.metadata.jobconf) setJobconf(data.data.metadata.jobconf);
        }
        return data;
      })
      .catch((err) => {
        toast.error(`Load ailab failed!`);
        console.log(err);
      });
  };

  const saveAILab = async () => {
    setIsDirty(false);
    var payload = {
      id: ailab_id,
      img:
        sketchData?.imgurl && sketchData?.imgurl.length > 0
          ? { url: sketchData.imgurl, type: sketchData.type, name: "ailab" }
          : {},
      metadata: { sketchData: sketchData, resultData: resultData, jobconf: jobconf },
    };
    api.ailab.save(payload);
  };

  useEffect(() => {
    if (isDirty) {
      saveAILab();
    }
  }, [isDirty]);

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth - 28);
      setHeight(window.innerHeight - 90 - 30);
    }
    loadAILab();
    handleResize();
    window.addEventListener("resize", handleResize);
  }, []);

  const handleUploadFabric = async ({ file }) => {
    setUploading(true);
    var name = nanoid() + ".png";
    var blob = await resizeImg(file, sketchWidth, sketchHeight);
    var file2 = new File([blob], name, { type: file.type });
    const url = await api.uploads.create([file2], {}, ailab_id).then(({ data }) => {
      const uploaded = data.uploads.map(({ url }) => url);
      return uploaded;
    });
    if (url && url.length == 1) {
      setSketchData({ ...sketchData, fabric_imgurl: url[0] });
      setIsDirty(true);
    }
    setUploading(false);
  };

  const handleUpload = async ({ file }) => {
    setUploading(true);
    var rid = nanoid();
    var name = rid + "." + file.name.split(".").pop();
    var blob = await resizeImg(file, sketchWidth, sketchHeight);
    var file2 = new File([blob], name, { type: file.type });
    const url = await api.uploads.create([file2], {}, ailab_id).then(({ data }) => {
      const uploaded = data.uploads.map(({ url }) => url);
      return uploaded;
    });
    if (url && url.length == 1) {
      var data = {
        name: file2.name,
        type: file2.type,
        imgurl: url[0],
        height: maxImagePixels,
        width: maxImagePixels,
      };
      setSketchData(data);
      setIsDirty(true);
    }
    setUploading(false);
  };

  const getThumbnail = async (url) => {
    function blobToBase64(blob) {
      return new Promise((resolve, _) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    }

    const response = await api.uploads.downloadurl({ url: url });
    var uri = "data:" + response.data.contenttype + ";base64," + response.data.base64;
    const file = dataURLtoFile(uri, nanoid());
    var blob = await resizeImg(file, sketchWidth / 4, sketchHeight / 4);
    var base64str = await blobToBase64(blob);
    //console.log('base64str', base64str.length)
    return base64str;
  };

  const runAIJob = async (newjobconf) => {
    //POST to http://localhost:9008/admin/ai-job
    setUploading(true);
    setJobconf(newjobconf);
    var task_type = newjobconf.task_type;
    if (!task_type || task_type === "")
      task_type = (sketchData ? taskOptions : taskOptions_NoImg)[0].value;
    var imgurl = task_type === "gen.flat.sd" ? "" : sketchData?.imgurl;
    if (task_type === "fabric") imgurl = [imgurl, sketchData?.fabric_imgurl];
    var jobid = ailab_id + "/" + task_type + "_" + nanoid();
    var taskData = {
      task_type: task_type,
      id: jobid,
      owner_id: account.id,
      task_meta: {
        conditional: imgurl,
        prompt: newjobconf.prompt,
        negative_prompt: newjobconf.negative_prompt,
        batch_size: newjobconf.batch_size,
        max_num_inference_steps: newjobconf.max_num_inference_steps ?? 20,
        conditioning_scale: newjobconf.conditioning_scale,
        guidance_scale: newjobconf.guidance_scale,
        coarse: newjobconf.coarse,
      },
    };
    //console.log('taskData', taskData, 'newjobconf', newjobconf)
    await new Promise((resolve) => setTimeout(resolve, 100));
    api.ailab
      .sendJob(taskData)
      .then(async ({ data }) => {
        var images = data["results"];
        //console.log('taskData', taskData, 'data', data)
        var newImages = await Promise.all(
          images.map(async (url) => {
            return { url: url, thumbnail: await getThumbnail(url) };
          })
        );
        //console.log('newImages', newImages)
        setResultData([{ taskData: taskData, images: newImages, dt: new Date() }, ...resultData]);
        setIsDirty(true);
        setUploading(false);
      })
      .catch((err) => {
        console.log(err);
        toast.error("Error to generate AI results!");
        setUploading(false);
      });
  };

  const handleChangeName = async () => {
    let value = nameInputRef?.current?.value || "";
    value = value.trim();
    if (value == labData.name || !value) {
      setEditNameVisible(false);
      return;
    }
    try {
      await api.ailab.save({ id: ailab_id, name: value });
      setLabData({ ...labData, name: value });
      toast.success("Update name successfully!");
    } catch (err) {
      console.log(err);
      toast.failed("Update name failed!");
    }
    setEditNameVisible(false);
  };

  const EditImagePanel = forwardRef((props, ref) => {
    const [editImageMode, setEditImageMode] = useState(1);
    const editImgRef = useRef(null);
    const uri = stageRef.current?.toDataURL();
    //https://github.com/nhn/tui.image-editor/blob/master/apps/image-editor/src/js/ui/theme/standard.js
    const myTheme = {
      "header.display": "none",
      //'common.backgroundColor': '#e0e0e0',
      //'submenu.backgroundColor': '#e0e0e0',
    };

    useImperativeHandle(ref, () => ({
      mode: editImageMode,
      setMode(mode) {
        setEditImageMode(mode);
      },
    }));

    const saveEditImg = async () => {
      setEditImageMode(0);
      setInitEditImage(false);
      const editorInstance = editImgRef.current.getInstance();
      const file = dataURLtoFile(editorInstance.toDataURL(), nanoid());
      var blob = await resizeImg(file, sketchWidth, sketchHeight);
      var file2 = new File([blob], file.name, { type: file.type });
      const uploadedImg = await api.uploads
        .create([file2], {}, ailab_id)
        .then(({ data }) => {
          const uploaded = data.uploads.map(({ url }) => url);
          return uploaded;
        })
        .catch((err) => {
          console.log(err);
          toast.error("Save image failed!");
        });
      if (uploadedImg.length === 1) {
        var url = uploadedImg[0];
        const { width, height } = await getImageDimensions(url);
        setSketchData({ ...sketchData, imgurl: url, width: width, height: height });
        setIsDirty(true);
      }
    };

    return (
      <SuiBox sx={{ display: editImageMode == 0 ? "none" : "" }}>
        <SuiBox display="flex" alignItems="center" justifyContent="center" sx={{ m: 1 }}>
          <SuiButton
            sx={{ mx: 2 }}
            onClick={() => {
              setEditImageMode(0);
            }}
            color={"dark"}
            variant="gradient"
          >
            Hide
          </SuiButton>
          <SuiButton sx={{ mx: 2 }} onClick={saveEditImg} color={"dark"} variant="gradient">
            Save & Close
          </SuiButton>
        </SuiBox>
        <DialogContent sx={{ overflowX: "auto", py: 0 }}>
          <SuiBox display="flex" alignItems="center" justifyContent="center">
            <div style={{ position: "relative", top: "-50px", left: "0px" }}>
              {uri && (
                <ImageEditor
                  ref={editImgRef}
                  includeUI={{
                    theme: myTheme,
                    loadImage: {
                      path: uri,
                      name: "image",
                    },
                    uiSize: {
                      width: "910px",
                      height: "700px",
                    },
                    menuBarPosition: "right",
                    menu: [
                      "crop",
                      "rotate",
                      "draw",
                      "eraser",
                      "shape",
                      "icon",
                      "text",
                      "mask",
                      "filter",
                    ],
                    initMenu: "draw",
                  }}
                  cssMaxHeight={500}
                  cssMaxWidth={500}
                  usageStatistics={false}
                  selectionStyle={{
                    cornerSize: 5,
                    rotatingPointOffset: 70,
                  }}
                />
              )}
            </div>
          </SuiBox>
        </DialogContent>
      </SuiBox>
    );
  });

  const TextToImagePanel = ({}) => {
    const [localJobconf, setLocalJobconf] = useState({ ...jobconf });

    return (
      <TabPanel value={tabValue} index={"text-to-image"}>
        <SuiTypography sx={{ mx: 1 }}>Prompt:</SuiTypography>
        <SuiBox sx={{ width: leftPanelWidth - 30, mx: 1, mb: 1 }}>
          <SuiInput
            size="small"
            multiline
            maxRows={3}
            minRows={3}
            placeholder="What do you want to see?"
            value={localJobconf.prompt}
            onChange={(e) => {
              setLocalJobconf({ ...localJobconf, prompt: e.target.value });
            }}
            onKeyDown={(e) => {
              if (e.keyCode == 13) {
                runAIJob({ ...localJobconf, task_type: "gen.flat.sd" });
              }
            }}
          />
        </SuiBox>
        <SuiBox
          sx={{ width: leftPanelWidth - 20, mx: 1, mb: 1 }}
          className="flex items-center justify-between"
        >
          <SuiTypography>Result Size:</SuiTypography>
          <SuiBox display="flex" alignItems="center" sx={{ width: leftPanelWidth - 160, mr: 1 }}>
            <Slider
              step={1}
              value={localJobconf.batch_size}
              aria-label="Default"
              valueLabelDisplay="auto"
              min={1}
              max={12}
              onChange={(e) => {
                setLocalJobconf({ ...localJobconf, batch_size: e.target.value });
              }}
            />
          </SuiBox>
        </SuiBox>
        <SuiBox sx={{ width: leftPanelWidth, mb: 1 }}>
          <SuiBox display="flex" alignItems="center" sx={{ justifyContent: "start" }}>
            <IconButton
              size="small"
              onClick={() => setExpanded(!expanded)}
              aria-expanded={expanded}
              aria-label="show more"
            >
              {expanded ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
              <SuiTypography variant="body1" sx={{ display: "block", ml: 1, color: "#4B5563" }}>
                Advanced Options
              </SuiTypography>
            </IconButton>
          </SuiBox>
          <Collapse in={expanded} timeout="auto" unmountOnExit>
            <SuiBox sx={{ ml: "30px" }}>
              <SuiBox
                sx={{ width: leftPanelWidth - 50, mx: 1, mb: 1 }}
                className="flex items-center justify-between"
              >
                <SuiTypography>Inference Steps:</SuiTypography>
                <SuiBox
                  display="flex"
                  alignItems="center"
                  sx={{ width: leftPanelWidth - 210, mr: 1 }}
                >
                  <Slider
                    step={5}
                    value={localJobconf.max_num_inference_steps ?? 20}
                    aria-label="Default"
                    valueLabelDisplay="auto"
                    min={10}
                    max={50}
                    onChange={(e) => {
                      setLocalJobconf({ ...localJobconf, max_num_inference_steps: e.target.value });
                    }}
                  />
                </SuiBox>
              </SuiBox>
              <SuiBox
                sx={{ width: leftPanelWidth - 50, mx: 1, mb: 1 }}
                className="flex items-center justify-between"
              >
                <SuiTypography>Imagination Level:</SuiTypography>
                <SuiBox
                  display="flex"
                  alignItems="center"
                  sx={{ width: leftPanelWidth - 210, mr: 1 }}
                >
                  <Slider
                    step={0.5}
                    value={localJobconf.guidance_scale ?? 7}
                    aria-label="Default"
                    valueLabelDisplay="auto"
                    min={4}
                    max={10}
                    onChange={(e) => {
                      setLocalJobconf({ ...localJobconf, guidance_scale: e.target.value });
                    }}
                  />
                </SuiBox>
              </SuiBox>
              <SuiBox
                sx={{ width: leftPanelWidth - 50, mx: 1, mb: 1 }}
                className="flex items-center justify-between"
              >
                <SuiTypography>Negative Prompt:</SuiTypography>
                <SuiBox sx={{ width: leftPanelWidth - 220, mr: 2 }}>
                  <SuiInput
                    size="small"
                    multiline
                    maxRows={2}
                    minRows={2}
                    value={localJobconf.negative_prompt}
                    placeholder="What do you want to avoid?"
                    onChange={(e) => {
                      setLocalJobconf({ ...localJobconf, negative_prompt: e.target.value });
                    }}
                  />
                </SuiBox>
              </SuiBox>
            </SuiBox>
          </Collapse>
        </SuiBox>
        <SuiButton
          sx={{ width: "100%", p: 1 }}
          onClick={() => {
            runAIJob({ ...localJobconf, task_type: "gen.flat.sd" });
          }}
          color={"dark"}
          variant="gradient"
        >
          Generate
        </SuiButton>
      </TabPanel>
    );
  };

  const ImageTransformationPanel = ({}) => {
    const [localJobconf, setLocalJobconf] = useState({ ...jobconf });

    return (
      <TabPanel value={tabValue} index={"image-transformation"}>
        {!sketchData?.imgurl && (
          <SuiBox display="flex" alignItems="center" justifyContent="center">
            <Card sx={{ width: 200, height: 200 }}>
              <SuiBox
                sx={{ width: "100%", height: "100%" }}
                className="flex items-center justify-center"
              >
                <Upload
                  accept="image/*"
                  fileList={[]}
                  multiple
                  showUploadList={false}
                  customRequest={handleUpload}
                >
                  <SuiButton
                    sx={{ mx: 0, p: 0, textTransform: "none" }}
                    size="medium"
                    variant="text"
                    color="dark"
                    startIcon={<UploadIcon fontSize="large" />}
                  >
                    Upload the image you want to transform
                  </SuiButton>
                </Upload>
              </SuiBox>
            </Card>
          </SuiBox>
        )}
        {sketchData?.imgurl && (
          <SuiBox>
            <SuiBox display="flex" alignItems="center" justifyContent="center">
              <SuiBox sx={{ width: 200 }} className="flex items-center justify-start">
                <Tooltip title="Upload a new image">
                  <SuiBox sx={{ lineHeight: 0 }}>
                    <Upload
                      fileList={[]}
                      accept="image/*"
                      showUploadList={false}
                      customRequest={handleUpload}
                    >
                      <div style={{ display: "flex", alignItems: "center", color: "#7C7D7D" }}>
                        <IconButton>
                          <UploadIcon
                            fontSize="medium"
                            color="inherit"
                            className="border-none hover:bg-transparent"
                          />
                        </IconButton>
                      </div>
                    </Upload>
                  </SuiBox>
                </Tooltip>
                <Tooltip title="Modify the image">
                  <IconButton
                    onClick={() => {
                      if (!initEditImage) setInitEditImage(true);
                      else editImageRef.current.setMode(1 - editImageRef.current.mode);
                    }}
                  >
                    <EditIcon
                      fontSize="medium"
                      color="inherit"
                      className="border-none hover:bg-transparent"
                    />
                  </IconButton>
                </Tooltip>
              </SuiBox>
            </SuiBox>
            <SuiBox display="flex" alignItems="center" justifyContent="center">
              <img
                src={sketchData.imgurl}
                crossOrigin="Anonymous"
                width="200px"
                height="200px"
                style={{ border: "1px solid #000000" }}
                onClick={() => {
                  if (!initEditImage) setInitEditImage(true);
                  else editImageRef.current.setMode(1 - editImageRef.current.mode);
                }}
              />
            </SuiBox>
            <SuiTypography sx={{ mx: 1 }}>Prompt:</SuiTypography>
            <SuiBox sx={{ width: leftPanelWidth - 40, mx: 1, mb: 1 }}>
              <SuiInput
                size="small"
                multiline
                maxRows={3}
                minRows={3}
                value={localJobconf.prompt}
                placeholder="What do you want to see?"
                onChange={(e) => {
                  setLocalJobconf({ ...localJobconf, prompt: e.target.value });
                }}
                onKeyDown={(e) => {
                  if (e.keyCode == 13) {
                    runAIJob({ ...localJobconf, task_type: "gen.flat" });
                  }
                }}
              />
            </SuiBox>
            <SuiBox
              sx={{ width: leftPanelWidth - 40, mx: 1, mb: 1 }}
              className="flex items-center justify-between"
            >
              <SuiTypography>Result Size:</SuiTypography>
              <SuiBox
                display="flex"
                alignItems="center"
                sx={{ width: leftPanelWidth - 160, mr: 1 }}
              >
                <Slider
                  step={1}
                  value={localJobconf.batch_size}
                  aria-label="Default"
                  valueLabelDisplay="auto"
                  min={1}
                  max={12}
                  onChange={(e) => {
                    setLocalJobconf({ ...localJobconf, batch_size: e.target.value });
                  }}
                />
              </SuiBox>
            </SuiBox>
            <SuiBox sx={{ width: leftPanelWidth, mb: 1 }}>
              <SuiBox display="flex" alignItems="center" sx={{ justifyContent: "start" }}>
                <IconButton
                  size="small"
                  onClick={() => setExpanded(!expanded)}
                  aria-expanded={expanded}
                  aria-label="show more"
                >
                  {expanded ? (
                    <ExpandLessIcon fontSize="small" />
                  ) : (
                    <ExpandMoreIcon fontSize="small" />
                  )}
                  <SuiTypography variant="body1" sx={{ display: "block", ml: 1, color: "#4B5563" }}>
                    Advanced Options
                  </SuiTypography>
                </IconButton>
              </SuiBox>
              <Collapse in={expanded} timeout="auto" unmountOnExit>
                <SuiBox sx={{ ml: "30px" }}>
                  <SuiBox
                    sx={{ width: leftPanelWidth - 50, mx: 1, mb: 1 }}
                    className="flex items-center justify-between"
                  >
                    <SuiTypography>Inference Steps:</SuiTypography>
                    <SuiBox
                      display="flex"
                      alignItems="center"
                      sx={{ width: leftPanelWidth - 210, mr: 1 }}
                    >
                      <Slider
                        step={5}
                        value={localJobconf.max_num_inference_steps ?? 20}
                        aria-label="Default"
                        valueLabelDisplay="auto"
                        min={10}
                        max={50}
                        onChange={(e) => {
                          setLocalJobconf({
                            ...localJobconf,
                            max_num_inference_steps: e.target.value,
                          });
                        }}
                      />
                    </SuiBox>
                  </SuiBox>
                  <SuiBox
                    sx={{ width: leftPanelWidth - 50, mx: 1, mb: 1 }}
                    className="flex items-center justify-between"
                  >
                    <SuiTypography>Imagination Level:</SuiTypography>
                    <SuiBox
                      display="flex"
                      alignItems="center"
                      sx={{ width: leftPanelWidth - 210, mr: 1 }}
                    >
                      <Slider
                        step={0.5}
                        value={localJobconf.guidance_scale ?? 7}
                        aria-label="Default"
                        valueLabelDisplay="auto"
                        min={4}
                        max={10}
                        onChange={(e) => {
                          setLocalJobconf({ ...localJobconf, guidance_scale: e.target.value });
                        }}
                      />
                    </SuiBox>
                  </SuiBox>
                  <SuiBox
                    sx={{ width: leftPanelWidth - 50, mx: 1, mb: 1 }}
                    className="flex items-center justify-between"
                  >
                    <SuiTypography>Control Level:</SuiTypography>
                    <SuiBox
                      display="flex"
                      alignItems="center"
                      sx={{ width: leftPanelWidth - 210, mr: 1 }}
                    >
                      <Slider
                        step={0.1}
                        value={localJobconf.conditioning_scale ?? 1}
                        aria-label="Default"
                        valueLabelDisplay="auto"
                        min={0.5}
                        max={2}
                        onChange={(e) => {
                          setLocalJobconf({ ...localJobconf, conditioning_scale: e.target.value });
                        }}
                      />
                    </SuiBox>
                  </SuiBox>
                  <SuiBox
                    sx={{ width: leftPanelWidth - 50, mx: 1, mb: 1 }}
                    className="flex items-center justify-between"
                  >
                    <SuiTypography>Negative Prompt:</SuiTypography>
                    <SuiBox sx={{ width: leftPanelWidth - 220, mr: 2 }}>
                      <SuiInput
                        size="small"
                        multiline
                        maxRows={2}
                        minRows={2}
                        value={localJobconf.negative_prompt}
                        placeholder="What do you want to avoid?"
                        onChange={(e) => {
                          setLocalJobconf({ ...localJobconf, negative_prompt: e.target.value });
                        }}
                      />
                    </SuiBox>
                  </SuiBox>
                </SuiBox>
              </Collapse>
            </SuiBox>
            <SuiButton
              sx={{ width: "100%", p: 1 }}
              onClick={() => {
                runAIJob({ ...localJobconf, task_type: "gen.flat" });
              }}
              color={"dark"}
              variant="gradient"
            >
              Generate
            </SuiButton>
          </SuiBox>
        )}
      </TabPanel>
    );
  };

  const InpaintPanel = forwardRef((props, ref) => {
    const [localJobconf, setLocalJobconf] = useState({ ...inpaintJobconf });
    const [selectedAreaPerc, setSelectedAreaPerc] = useState(null);

    const myRef = useRef(null);

    useImperativeHandle(ref, () => ({
      setSelectedAreaPercFunc(p) {
        setSelectedAreaPerc(p);
      },
    }));

    const runInPaint = async () => {
      if (!segmentImageRef.current.selectedSegment) {
        toast.error("Please select the designated area first");
        return;
      }
      if (!(localJobconf.batch_size > 0 && localJobconf.batch_size <= 12)) {
        toast.error("Result size should be between 1 and 12");
        return;
      }
      if (localJobconf.prompt === "") {
        toast.error("Prompt can not be empty");
        return;
      }
      props.resultRef.current.focus();
      setInpaintJobconf(localJobconf);
      setUploading(true);
      var segment = segmentImageRef.current.selectedSegment;
      var maskArea = segment.maskArea;
      if (localJobconf.inpaint_mask === "nonmask") {
        maskArea = [...maskArea].map((m) => 1 - m);
      }
      var imgurl = sketchData.imgurl;
      var jobid = ailab_id + "/inpaint_" + nanoid();
      var taskData = {
        task_type: "gen.flat.inpaint",
        id: jobid,
        owner_id: account.id,
        task_meta: {
          batch_size: localJobconf.batch_size,
          max_num_inference_steps: 20,
          conditional: imgurl,
          prompt: localJobconf.prompt,
          negative_prompt: localJobconf.negative_prompt,
          mask_RLE: {
            counts: convertToRLE(maskArea),
            size: [sketchWidth, sketchHeight],
          },
        },
      };
      //console.log('segment', segment)
      console.log("taskData", taskData);
      api.ailab
        .sendJob(taskData)
        .then(async ({ data }) => {
          var images = data["results"];
          //console.log('taskData', taskData, 'data', data)
          var newImages = await Promise.all(
            images.map(async (url) => {
              return { url: url, thumbnail: await getThumbnail(url) };
            })
          );
          //console.log('newImages', newImages)
          setResultData([{ taskData: taskData, images: newImages, dt: new Date() }, ...resultData]);
          setIsDirty(true);
          setUploading(false);
        })
        .catch((err) => {
          console.log(err);
          toast.error("Error to generate AI results!");
          setUploading(false);
        });
    };

    return (
      <TabPanel value={tabValue} index={"inpaint"}>
        {!sketchData?.imgurl && (
          <SuiBox display="flex" alignItems="center" justifyContent="center">
            <Card sx={{ width: 200, height: 200 }}>
              <SuiBox
                sx={{ width: "100%", height: "100%" }}
                className="flex items-center justify-center"
              >
                <Upload
                  accept="image/*"
                  fileList={[]}
                  multiple
                  showUploadList={false}
                  customRequest={handleUpload}
                >
                  <SuiButton
                    sx={{ mx: 0, p: 0, textTransform: "none" }}
                    size="medium"
                    variant="text"
                    color="dark"
                    startIcon={<UploadIcon fontSize="large" />}
                  >
                    Upload the image you want to inpaint
                  </SuiButton>
                </Upload>
              </SuiBox>
            </Card>
          </SuiBox>
        )}
        {sketchData?.imgurl && (
          <SuiBox>
            <SuiBox display="flex" alignItems="center" justifyContent="center">
              <SuiBox sx={{ width: 200 }} className="flex items-center justify-start">
                <Tooltip title="Upload a new image">
                  <SuiBox sx={{ lineHeight: 0 }}>
                    <Upload
                      fileList={[]}
                      accept="image/*"
                      showUploadList={false}
                      customRequest={handleUpload}
                    >
                      <div style={{ display: "flex", alignItems: "center", color: "#7C7D7D" }}>
                        <IconButton>
                          <UploadIcon
                            fontSize="medium"
                            color="inherit"
                            className="border-none hover:bg-transparent"
                          />
                        </IconButton>
                      </div>
                    </Upload>
                  </SuiBox>
                </Tooltip>
                <Tooltip title="Modify the image">
                  <IconButton
                    onClick={() => {
                      if (!initEditImage) setInitEditImage(true);
                      else editImageRef.current.setMode(1 - editImageRef.current.mode);
                    }}
                  >
                    <EditIcon
                      fontSize="medium"
                      color="inherit"
                      className="border-none hover:bg-transparent"
                    />
                  </IconButton>
                </Tooltip>
              </SuiBox>
            </SuiBox>
            <SuiBox display="flex" alignItems="center" justifyContent="center">
              <img
                src={sketchData.imgurl}
                crossOrigin="Anonymous"
                width="200px"
                height="200px"
                style={{ border: "1px solid #000000" }}
              />
            </SuiBox>
            <SuiBox sx={{ width: "100%" }}>
              <SuiBox
                display="flex"
                sx={{ width: "100%", lineHeight: 1.25, mt: 2, mb: 0.5, mx: 1 }}
              >
                <SuiTypography fontWeight="medium">
                  Transform the designated area (
                  {selectedAreaPerc != null ? selectedAreaPerc : "None"}):
                </SuiTypography>
              </SuiBox>
              <SuiTypography sx={{ mx: 1 }}>Prompt:</SuiTypography>
              <SuiBox sx={{ width: leftPanelWidth - 40, mx: 1, mb: 1 }}>
                <SuiInput
                  size="small"
                  multiline
                  maxRows={3}
                  minRows={3}
                  value={localJobconf.prompt}
                  placeholder="What do you want to see?"
                  onChange={(e) => {
                    setLocalJobconf({ ...localJobconf, prompt: e.target.value });
                  }}
                  onKeyDown={(e) => {
                    if (e.keyCode == 13) {
                      runInPaint();
                    }
                  }}
                />
              </SuiBox>
              <SuiBox sx={{ width: 430, ml: 2, mb: 0.5 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={localJobconf.inpaint_mask === "nonmask"}
                      onChange={(e) => {
                        setLocalJobconf({
                          ...localJobconf,
                          inpaint_mask: e.target.checked ? "nonmask" : "mask",
                        });
                      }}
                    />
                  }
                  label={<SuiTypography>Inpaint areas outside the designated area</SuiTypography>}
                />
              </SuiBox>
              <SuiBox
                sx={{ width: leftPanelWidth - 40, mx: 1, mb: 1 }}
                className="flex items-center justify-between"
              >
                <SuiTypography>Result Size:</SuiTypography>
                <SuiBox
                  display="flex"
                  alignItems="center"
                  sx={{ width: leftPanelWidth - 160, mr: 1 }}
                >
                  <Slider
                    step={1}
                    value={localJobconf.batch_size}
                    aria-label="Default"
                    valueLabelDisplay="auto"
                    min={1}
                    max={12}
                    onChange={(e) => {
                      setLocalJobconf({ ...localJobconf, batch_size: e.target.value });
                    }}
                  />
                </SuiBox>
              </SuiBox>
              <SuiBox sx={{ width: leftPanelWidth, mb: 1 }}>
                <SuiBox display="flex" alignItems="center" sx={{ justifyContent: "start" }}>
                  <IconButton
                    size="small"
                    onClick={() => setExpanded(!expanded)}
                    aria-expanded={expanded}
                    aria-label="show more"
                  >
                    {expanded ? (
                      <ExpandLessIcon fontSize="small" />
                    ) : (
                      <ExpandMoreIcon fontSize="small" />
                    )}
                    <SuiTypography
                      variant="body1"
                      sx={{ display: "block", ml: 1, color: "#4B5563" }}
                    >
                      Advanced Options
                    </SuiTypography>
                  </IconButton>
                </SuiBox>
                <Collapse in={expanded} timeout="auto" unmountOnExit>
                  <SuiBox sx={{ ml: "30px" }}>
                    <SuiBox
                      sx={{ width: leftPanelWidth - 50, mx: 1, mb: 1 }}
                      className="flex items-center justify-between"
                    >
                      <SuiTypography>Negative Prompt:</SuiTypography>
                      <SuiBox sx={{ width: leftPanelWidth - 220, mr: 2 }}>
                        <SuiInput
                          size="small"
                          multiline
                          maxRows={2}
                          minRows={2}
                          value={localJobconf.negative_prompt}
                          placeholder="What do you want to avoid?"
                          onChange={(e) => {
                            setLocalJobconf({ ...localJobconf, negative_prompt: e.target.value });
                          }}
                        />
                      </SuiBox>
                    </SuiBox>
                  </SuiBox>
                </Collapse>
              </SuiBox>
              <Tooltip title="Type a prompt and use AI generation to transform the designated area">
                <SuiButton
                  sx={{ width: "100%", p: 1 }}
                  onClick={() => {
                    runInPaint();
                  }}
                  color={"dark"}
                  variant="gradient"
                >
                  Inpaint
                </SuiButton>
              </Tooltip>
            </SuiBox>
          </SuiBox>
        )}
      </TabPanel>
    );
  });

  const FabricPanel = ({}) => {
    const [localJobconf, setLocalJobconf] = useState({ ...jobconf });

    return (
      <TabPanel value={tabValue} index={"fabric"}>
        <SuiBox display="flex" alignItems="center" justifyContent="space-between">
          <SuiBox sx={{ mx: 2 }}>
            {!sketchData?.imgurl && (
              <Card sx={{ width: 200, height: 200 }}>
                <SuiBox
                  sx={{ width: "100%", height: "100%" }}
                  className="flex items-center justify-center"
                >
                  <Upload
                    accept="image/*"
                    fileList={[]}
                    multiple
                    showUploadList={false}
                    customRequest={handleUpload}
                  >
                    <SuiButton
                      sx={{ mx: 0, p: 0, textTransform: "none" }}
                      size="medium"
                      variant="text"
                      color="dark"
                      startIcon={<UploadIcon fontSize="large" />}
                    >
                      Upload sketch
                    </SuiButton>
                  </Upload>
                </SuiBox>
              </Card>
            )}
            {sketchData?.imgurl && (
              <SuiBox>
                <SuiBox display="flex" alignItems="center" justifyContent="center">
                  <SuiBox sx={{ width: 200 }} className="flex items-center justify-start">
                    <Tooltip title="Upload a new image">
                      <SuiBox sx={{ lineHeight: 0 }}>
                        <Upload
                          fileList={[]}
                          accept="image/*"
                          showUploadList={false}
                          customRequest={handleUpload}
                        >
                          <div style={{ display: "flex", alignItems: "center", color: "#7C7D7D" }}>
                            <IconButton>
                              <UploadIcon
                                fontSize="medium"
                                color="inherit"
                                className="border-none hover:bg-transparent"
                              />
                            </IconButton>
                          </div>
                        </Upload>
                      </SuiBox>
                    </Tooltip>
                  </SuiBox>
                </SuiBox>
                <SuiBox display="flex" alignItems="center" justifyContent="center">
                  <img
                    src={sketchData.imgurl}
                    crossOrigin="Anonymous"
                    width="200px"
                    height="200px"
                    style={{ border: "1px solid #000000" }}
                  />
                </SuiBox>
              </SuiBox>
            )}
          </SuiBox>
          <SuiBox sx={{ mx: 2 }}>
            {!sketchData?.fabric_imgurl && (
              <Card sx={{ width: 200, height: 200 }}>
                <SuiBox
                  sx={{ width: "100%", height: "100%" }}
                  className="flex items-center justify-center"
                >
                  <Upload
                    accept="image/*"
                    fileList={[]}
                    multiple
                    showUploadList={false}
                    customRequest={handleUploadFabric}
                  >
                    <SuiButton
                      sx={{ mx: 0, p: 0, textTransform: "none" }}
                      size="medium"
                      variant="text"
                      color="dark"
                      startIcon={<UploadIcon fontSize="large" />}
                    >
                      Upload the fabric image
                    </SuiButton>
                  </Upload>
                </SuiBox>
              </Card>
            )}
            {sketchData?.fabric_imgurl && (
              <SuiBox>
                <SuiBox display="flex" alignItems="center" justifyContent="center">
                  <SuiBox sx={{ width: 200 }} className="flex items-center justify-start">
                    <Tooltip title="Upload a new fabric image">
                      <SuiBox sx={{ lineHeight: 0 }}>
                        <Upload
                          fileList={[]}
                          accept="image/*"
                          showUploadList={false}
                          customRequest={handleUploadFabric}
                        >
                          <div style={{ display: "flex", alignItems: "center", color: "#7C7D7D" }}>
                            <IconButton>
                              <UploadIcon
                                fontSize="medium"
                                color="inherit"
                                className="border-none hover:bg-transparent"
                              />
                            </IconButton>
                          </div>
                        </Upload>
                      </SuiBox>
                    </Tooltip>
                  </SuiBox>
                </SuiBox>
                <SuiBox display="flex" alignItems="center" justifyContent="center">
                  <img
                    src={sketchData.fabric_imgurl}
                    crossOrigin="Anonymous"
                    width="200px"
                    height="200px"
                    style={{ border: "1px solid #000000" }}
                  />
                </SuiBox>
              </SuiBox>
            )}
          </SuiBox>
        </SuiBox>
        {sketchData?.imgurl && sketchData?.fabric_imgurl && (
          <SuiBox>
            <SuiTypography sx={{ mx: 1 }}>Prompt:</SuiTypography>
            <SuiBox sx={{ width: leftPanelWidth - 40, mx: 1, mb: 1 }}>
              <SuiInput
                size="small"
                multiline
                maxRows={3}
                minRows={3}
                value={localJobconf.prompt}
                placeholder="What do you want to see?"
                onChange={(e) => {
                  setLocalJobconf({ ...localJobconf, prompt: e.target.value });
                }}
                onKeyDown={(e) => {
                  if (e.keyCode == 13) {
                    runAIJob({ ...localJobconf, task_type: "fabric" });
                  }
                }}
              />
            </SuiBox>
            {false && (
              <SuiBox
                sx={{ width: leftPanelWidth - 40, mx: 1, mb: 1 }}
                className="flex items-center justify-between"
              >
                <SuiTypography>Result Size:</SuiTypography>
                <SuiBox
                  display="flex"
                  alignItems="center"
                  sx={{ width: leftPanelWidth - 160, mr: 1 }}
                >
                  <Slider
                    step={1}
                    value={localJobconf.batch_size}
                    aria-label="Default"
                    valueLabelDisplay="auto"
                    min={1}
                    max={12}
                    onChange={(e) => {
                      setLocalJobconf({ ...localJobconf, batch_size: e.target.value });
                    }}
                  />
                </SuiBox>
              </SuiBox>
            )}
            <SuiBox sx={{ width: leftPanelWidth, mb: 1 }}>
              <SuiBox display="flex" alignItems="center" sx={{ justifyContent: "start" }}>
                <IconButton
                  size="small"
                  onClick={() => setExpanded(!expanded)}
                  aria-expanded={expanded}
                  aria-label="show more"
                >
                  {expanded ? (
                    <ExpandLessIcon fontSize="small" />
                  ) : (
                    <ExpandMoreIcon fontSize="small" />
                  )}
                  <SuiTypography variant="body1" sx={{ display: "block", ml: 1, color: "#4B5563" }}>
                    Advanced Options
                  </SuiTypography>
                </IconButton>
              </SuiBox>
              <Collapse in={expanded} timeout="auto" unmountOnExit>
                <SuiBox sx={{ ml: "30px" }}>
                  <SuiBox
                    sx={{ width: leftPanelWidth - 50, mx: 1, mb: 1 }}
                    className="flex items-center justify-between"
                  >
                    <SuiTypography>Inference Steps:</SuiTypography>
                    <SuiBox
                      display="flex"
                      alignItems="center"
                      sx={{ width: leftPanelWidth - 210, mr: 1 }}
                    >
                      <Slider
                        step={5}
                        value={localJobconf.max_num_inference_steps ?? 20}
                        aria-label="Default"
                        valueLabelDisplay="auto"
                        min={10}
                        max={50}
                        onChange={(e) => {
                          setLocalJobconf({
                            ...localJobconf,
                            max_num_inference_steps: e.target.value,
                          });
                        }}
                      />
                    </SuiBox>
                  </SuiBox>
                  <SuiBox
                    sx={{ width: leftPanelWidth - 50, mx: 1, mb: 1 }}
                    className="flex items-center justify-between"
                  >
                    <SuiTypography>Imagination Level:</SuiTypography>
                    <SuiBox
                      display="flex"
                      alignItems="center"
                      sx={{ width: leftPanelWidth - 210, mr: 1 }}
                    >
                      <Slider
                        step={0.5}
                        value={localJobconf.guidance_scale ?? 7}
                        aria-label="Default"
                        valueLabelDisplay="auto"
                        min={4}
                        max={10}
                        onChange={(e) => {
                          setLocalJobconf({ ...localJobconf, guidance_scale: e.target.value });
                        }}
                      />
                    </SuiBox>
                  </SuiBox>
                  <SuiBox
                    sx={{ width: leftPanelWidth - 50, mx: 1, mb: 1 }}
                    className="flex items-center justify-between"
                  >
                    <SuiTypography>Control Level:</SuiTypography>
                    <SuiBox
                      display="flex"
                      alignItems="center"
                      sx={{ width: leftPanelWidth - 210, mr: 1 }}
                    >
                      <Slider
                        step={0.1}
                        value={localJobconf.conditioning_scale ?? 1}
                        aria-label="Default"
                        valueLabelDisplay="auto"
                        min={0.5}
                        max={2}
                        onChange={(e) => {
                          setLocalJobconf({ ...localJobconf, conditioning_scale: e.target.value });
                        }}
                      />
                    </SuiBox>
                  </SuiBox>
                  <SuiBox
                    sx={{ width: leftPanelWidth - 50, mx: 1, mb: 1 }}
                    className="flex items-center justify-between"
                  >
                    <SuiTypography>Negative Prompt:</SuiTypography>
                    <SuiBox sx={{ width: leftPanelWidth - 220, mr: 2 }}>
                      <SuiInput
                        size="small"
                        multiline
                        maxRows={2}
                        minRows={2}
                        value={localJobconf.negative_prompt}
                        placeholder="What do you want to avoid?"
                        onChange={(e) => {
                          setLocalJobconf({ ...localJobconf, negative_prompt: e.target.value });
                        }}
                      />
                    </SuiBox>
                  </SuiBox>
                </SuiBox>
              </Collapse>
            </SuiBox>
            <SuiButton
              sx={{ width: "100%", p: 1 }}
              onClick={() => {
                runAIJob({ ...localJobconf, task_type: "fabric" });
              }}
              color={"dark"}
              variant="gradient"
            >
              Generate
            </SuiButton>
          </SuiBox>
        )}
      </TabPanel>
    );
  };

  const ResultPanel = forwardRef((props, ref) => {
    var rWidth = Math.max(512 + 22, width - leftPanelWidth - 40) - 70;
    const myRef = useRef(null);

    useImperativeHandle(ref, () => ({
      focus() {
        focusRef.current = true;
      },
    }));

    useEffect(() => {
      if (focusRef.current && resultData.length > 0) {
        myRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
        focusRef.current = false;
      }
    }, [resultData]);

    return (
      <SuiBox>
        <SuiBox ref={myRef} />
        {resultData.map((aiResult) => {
          //console.log('aiResult', aiResult, 'rWidth', rWidth)
          return (
            <SuiBox sx={{ width: rWidth, border: "0px solid", mx: 1, my: 1, overflow: "hidden" }}>
              <div class="flex select-none items-center justify-center w-full flex-row mt-4 mb-2">
                <div class="bg-black grow h-[1px]"></div>
                <div class="text-muted-white mx-2 flex items-center justify-center">
                  {smartdate.format(new Date(aiResult.dt))}
                </div>
                <div class="bg-black grow h-[1px]"></div>
              </div>
              <SuiBox sx={{ pt: 1 }}>
                <SuiBox display="flex" justifyContent1="space-between">
                  <SuiBox display="flex">
                    <SuiTypography sx={{ mx: 1 }}>
                      {aiResult.taskData.task_meta.prompt}
                    </SuiTypography>
                    {false && (
                      <Tooltip title="Reuse prompts">
                        <IconButton
                          onClick={() => {
                            setLocalJobconf({
                              ...localJobconf,
                              prompt: aiResult.taskData.task_meta.prompt,
                            });
                          }}
                          sx={{ mx: 1, p: 0 }}
                        >
                          <ArrowCircleLeftIcon />
                        </IconButton>
                      </Tooltip>
                    )}
                  </SuiBox>
                  <IconButton
                    aria-label="close"
                    onClick={() => {
                      setPromptConfig({
                        heading: "Delete Confirmation",
                        text: "Are you certain you want to delete all generated images?",
                        handleOk: () => {
                          const newresultData = resultData.filter(
                            (r) => aiResult.taskData.id !== r.taskData.id
                          );
                          setResultData(newresultData);
                          setIsDirty(true);
                        },
                      });
                    }}
                    sx={{ m: 0, p: 0 }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </SuiBox>
                <SuiBox display="flex" sx={{ flexWrap: "wrap" }}>
                  {aiResult.images.map((image) => {
                    return (
                      <SuiBox sx={{ width: (sketchWidth / 4) * 3 + 10 }}>
                        <SuiBox className="flex items-center justify-end">
                          <Tooltip title="Set following as initial image">
                            <IconButton
                              sx={{ p: 0 }}
                              onClick={() => {
                                //setTabValue(1);
                                setSketchData({ ...sketchData, imgurl: image.url });
                                setIsDirty(true);
                              }}
                            >
                              <ImageIcon />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Download following image">
                            <IconButton
                              sx={{ p: 0 }}
                              onClick={() => {
                                saveAs(image.url);
                              }}
                            >
                              <DownloadIcon />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Delete following image">
                            <IconButton
                              sx={{ p: 0 }}
                              onClick={() => {
                                setPromptConfig({
                                  heading: "Delete Confirmation",
                                  text: "Are you certain you want to delete this result image?",
                                  handleOk: () => {
                                    const newresultData = resultData.map((r) => {
                                      if (aiResult.taskData.id === r.taskData.id) {
                                        return {
                                          ...r,
                                          images: r.images.filter((i) => i !== image),
                                        };
                                      }
                                      return r;
                                    });
                                    setResultData(newresultData);
                                    setIsDirty(true);
                                  },
                                });
                              }}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Tooltip>
                        </SuiBox>
                        <img
                          style={{ margin: "4px", border: "1px solid" }}
                          src={image.url}
                          width={(sketchWidth / 4) * 3 + 2}
                          height={(sketchHeight / 4) * 3 + 2}
                          onClick={() => {
                            setLargeDetailImage(image.url);
                          }}
                        />
                      </SuiBox>
                    );
                  })}
                </SuiBox>
              </SuiBox>
            </SuiBox>
          );
        })}
      </SuiBox>
    );
  });

  //console.log('editNameVisible', editNameVisible, 'labData.name', labData?.name, 'labData', labData)
  return (
    <>
      {sketchData?.imgurl && (
        <div style={{ position: "fixed", top: -10000, left: -10000 }}>
          <img src={sketchData.imgurl} id="backgroundImage" crossOrigin="Anonymous" />
          <Stage ref={stageRef} className="konva" width={sketchWidth} height={sketchHeight}>
            <Layer>
              <KonvaImage image={background} width={sketchWidth} height={sketchHeight} />
            </Layer>
          </Stage>
        </div>
      )}
      <SuiBox mb={2} mt={-2.5}>
        <Backdrop sx={{ color: "info", zIndex: (theme) => 99999 }} open={uploading}>
          <CircularProgress color="info" sx={{ mr: 1 }} size={32} />
          <SuiTypography variant="h6" fontWeight="medium" color="info">
            Waiting...
          </SuiTypography>
        </Backdrop>
        <SimplePrompt promptConfig={promptConfig} setPromptConfig={setPromptConfig} />
        <NewSharedBar
          type="ailab"
          data={labData}
          title={
            <SuiBox display="flex" justifyContent="center" alignItems="center">
              {editNameVisible ? (
                <div className="flex">
                  <input
                    defaultValue={labData?.name}
                    ref={nameInputRef}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleChangeName();
                      }
                    }}
                    className="font-serif"
                    autoFocus
                    style={{
                      outline: "none",
                      border: "none",
                      width: inputWidth + "ch",
                      fontSize: "1.25rem",
                      lineHeight: 1.375,
                      fontWeight: 700,
                    }}
                    onChange={(e) => setInputWidth(e.target?.value?.length)}
                    onBlur={handleChangeName}
                  />
                </div>
              ) : (
                <SuiBox display="flex" alignItems="center" justifyContent="center" gap={0.5}>
                  <Tooltip title={"Click to modify the name."}>
                    <SuiTypography
                      variant="h5"
                      className="font-serif"
                      fontWeight="bold"
                      textTransform="none"
                      onClick={() => {
                        setEditNameVisible(true);
                        setInputWidth(labData?.name?.length);
                      }}
                    >
                      {labData?.name}
                    </SuiTypography>
                  </Tooltip>
                </SuiBox>
              )}
            </SuiBox>
          }
          handleRefreshSourceData={loadAILab}
          extraAction={
            <PlayCircleIcon
              sx={{ cursor: "pointer", zIndex: 2 }}
              onClick={() => setTutorialVisible(true)}
              color="dark"
              fontSize="medium"
            />
          }
        />
      </SuiBox>
      <SuiBox
        sx={{ display: "flex", width: width, height: height, m: 2, pt: "3px", overflow: "hidden" }}
      >
        {largeDetailImage && (
          <Prompt
            visible={true}
            handleClose={() => setLargeDetailImage(null)}
            handleOk={() => setLargeDetailImage(null)}
            option={{ maxWidth: "xl" }}
            text={
              <SuiBox pt={1}>
                <ImageCardWrapper
                  data={{
                    url: largeDetailImage,
                    name: "1.jpeg",
                    type: "image/jpeg",
                  }}
                  mode={"normal"}
                  sx={{ maxHeight: sketchWidth, minHeight: sketchHeight }}
                  isOriginalSize
                  pdfPagination={true}
                />
              </SuiBox>
            }
            hideAction
          />
        )}
        <SuiBox
          sx={{
            width: leftPanelWidth,
            minWidth: leftPanelWidth,
            maxHeight: height,
            border: "1px solid",
            mx: 1,
            px: 1,
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          <Tabs
            orientation={"horizontal"}
            value={tabValue}
            onChange={(event, newValue) => {
              setTabValue(newValue);
            }}
            sx={{ width: "100%" }}
          >
            <Tab label="Text-To-Image" {...a11yProps("text-to-image")} sx={{ width: 110 }} />
            <Tab label="Inpaint" {...a11yProps("inpaint")} sx={{ width: 110 }} />
            <Tab label="Fabric(Beta)" {...a11yProps("fabric")} sx={{ width: 110 }} />
            <Tab
              label="Image-Transformation"
              {...a11yProps("image-transformation")}
              sx={{ width: 150 }}
            />
          </Tabs>
          <TextToImagePanel />
          <ImageTransformationPanel />
          <InpaintPanel ref={inpaintRef} resultRef={resultRef} />
          <FabricPanel />
        </SuiBox>
        <SuiBox
          sx={{
            width: Math.max(512 + 22, width - leftPanelWidth - 4),
            maxHeight: height,
            border: "1px solid",
            mx: 1,
            overflow: "auto",
          }}
        >
          {initEditImage && <EditImagePanel ref={editImageRef} />}
          {tabValue === "inpaint" && sketchData?.imgurl && (
            <ShowSegmentImage
              ref={segmentImageRef}
              stageRef={stageRef}
              sketchWidth={sketchWidth}
              sketchHeight={sketchHeight}
              sketchData={sketchData}
              account={account}
              setSketchData={setSketchData}
              setIsDirty={setIsDirty}
              ailab_id={ailab_id}
              segmentsRef={segmentsRef}
              inpaintRef={inpaintRef}
            />
          )}
          <ResultPanel ref={resultRef} />
        </SuiBox>
        {tutorialVisible ? (
          <AILabPageTurorialModal
            visible={tutorialVisible}
            handleClose={() => setTutorialVisible(false)}
          />
        ) : null}
      </SuiBox>
    </>
  );
};

export default AILab;
